import type { PodBrand } from '@/types/pod'

/**
 * The ReZabond pod — branding layer (browser side).
 *
 * PROSPECT DEMO, NOT A LIVE CUSTOMER. ReZabond Surface & Play Ltd (Porth, South
 * Wales) are evaluating an assistant and are currently looking at a competitor's
 * offering. This pod exists so the owner, Gary Jones, can try ours against theirs
 * on his own material. Treat it as disposable until he signs: no promises are
 * made to ReZabond by its existence, and it comes down if he passes.
 *
 * SOURCE OF TRUTH. Every value below is lifted from rezabond.co.uk (all ten
 * pages, fetched 05 Aug 2026). Nothing is invented — the same discipline the
 * grounding fence enforces on the corpus applies to the config.
 *
 * PALETTE — PROVISIONAL. ReZabond publish no brand hex values and their site is
 * a Wix template; the palette below is a considered choice (deep forest green +
 * warm safety orange, reading as play/outdoor/safety) rather than a sampled
 * brand match. Sample their logo and site chrome before this goes in front of
 * Gary a second time, and replace these values. Flagged rather than silently
 * guessed.
 *
 * CONTACT. Phone and email are ReZabond's PUBLIC contact routes, as published
 * on their site. Gary's mobile is the SMS notify target and belongs in
 * workers/pod.ts — never here, or the assistant would hand his personal number
 * to every visitor.
 */
export const rezabondPod: PodBrand = {
  id: 'rezabond',
  brandName: 'ReZabond Surface & Play',
  productName: 'ReZabond Surface & Play',
  assistantName: 'Rezzi',
  tagline: 'Surfacing, play and inspection specialists across South Wales and beyond',
  roleLabel: 'surfacing and play assistant',
  welcomeIntro:
    "Ask me anything about ReZabond — surfacing, playgrounds, inspections, training or materials. If you want a quote for your site, tell me about it and Gary will come back to you.",
  starters: [
    'How much is the RPII inspection course?',
    'What surfacing do you use for playgrounds?',
    'Do you carry out annual inspections?',
    'What does EPDM cost?',
  ],
  inputPrompt: 'Ask Rezzi a question',
  footerNote:
    "Rezzi answers from ReZabond's own information — anything else goes straight to Gary.",
  theme: {
    // PROVISIONAL — see header note. Deep forest green + safety orange.
    '--color-brand-primary': '22 78 55', // deep green #164E37
    '--color-brand-primary-hover': '15 56 39', // darker green #0F3827
    '--color-brand-accent': '234 128 35', // safety orange #EA8023
    '--color-surface-base': '247 249 247', // off-white #F7F9F7
    '--color-surface-raised': '255 255 255',
    '--color-surface-subtle': '237 242 238', // pale green-grey #EDF2EE
    '--color-text-primary': '26 38 32', // near-black green #1A2620
    '--color-text-muted': '100 116 106', // muted green-grey #64746A
    '--color-text-danger': '178 47 47',
    '--color-border-subtle': '221 230 224', // soft green-grey #DDE6E0
  },
  contact: {
    phone: '029 2168 1288',
    email: 'info@rezabond.co.uk',
  },
}
